var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 58,
    viewBox: "0 0 71 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9033 16.3666C48.657 12.077 45.485 8.30348 40.9904 5.76332C36.4958 3.22315 30.9919 2.09344 25.5249 2.58892C20.0579 3.08439 15.0088 5.17051 11.3375 8.45074C7.66621 11.731 5.62857 15.9766 5.61191 20.3807C5.60781 23.2509 6.474 26.079 8.13611 28.6222C5.11023 29.9202 2.713 31.9903 1.3253 34.5037C-0.0623993 37.0172 -0.360967 39.8297 0.477032 42.4945C1.31503 45.1594 3.24153 47.5236 5.95044 49.2116C8.65936 50.8996 11.9953 51.8146 15.4283 51.8111H39.268V34.7803L32.8369 39.9282L28.8711 36.7537L38.1068 29.3608C39.1588 28.5191 40.5853 28.0462 42.0727 28.0462C43.5601 28.0462 44.9866 28.5191 46.0385 29.3608L55.2743 36.7537L51.3084 39.9282L44.8773 34.7803V51.8111C50.3719 51.7907 55.6662 50.1571 59.7562 47.2201C63.8462 44.2831 66.4477 40.2468 67.0674 35.8766C67.6871 31.5064 66.2819 27.1062 63.1182 23.5101C59.9546 19.914 55.2524 17.3722 49.9033 16.3666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.47ccb9a8c7a4af02c74ab7ec4fa16bf2.svg";
export { ForwardRef as ReactComponent };